const Ping = () => {
  return <div className="ping" />;
};

export default Ping;
